<template>
  <section>
    <h1 class="text-h3 mb-8">
      Skeleton loaders
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <div class="d-flex">
        <v-checkbox
          v-model="boilerplate"
          label="Boilerplate"
        />
        <v-checkbox
          v-model="tile"
          class="ml-8"
          label="Tile"
        />
        <v-spacer />
        <v-autocomplete
          v-model="type"
          :items="types"
        />
      </div>
      <v-card>
        <v-skeleton-loader
          :type="type"
          :boilerplate="boilerplate"
          :tile="tile"
        />
      </v-card>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/skeleton-loaders/">
      <strong>Skeleton loaders</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsSkeletonLoaders',
  data: () => ({
    types: [
      'actions',
      'article',
      'avatar',
      'button',
      'card',
      'card-avatar',
      'card-heading',
      'chip',
      'date-picker',
      'date-picker-options',
      'date-picker-days',
      'heading',
      'image',
      'list-item',
      'list-item-avatar',
      'list-item-two-line',
      'list-item-avatar-two-line',
      'list-item-three-line',
      'list-item-avatar-three-line',
      'paragraph',
      'sentences',
      'table',
      'table-heading',
      'table-thead',
      'table-tbody',
      'table-row-divider',
      'table-row',
      'table-cell',
      'table-tfoot',
      'text'
    ],
    type: 'card',
    boilerplate: false,
    tile: false
  })
}
</script>
